import type { ChainArch } from "@opensea/graphql"
import type { Awaitable } from "@opensea/utils"
import type { Address, Session } from "../../types"
import { createSiwxMessage } from "./utils/createSiwxMessage"

export type VerifyProps = {
  message: string
  signature: string
  chainArch: ChainArch
  connectorId?: string
}

export type ExchangeProps = {
  token: string
}

export type CreateMessageProps = {
  nonce: string
  address: Address
  chainId: number
  statement?: string
}

export abstract class SiweAdapter {
  public abstract getNonce(): Awaitable<string>
  public abstract verify(props: VerifyProps): Awaitable<Session>
  public abstract endSession(): Awaitable<void>
  public abstract getSession(): Awaitable<Session | undefined>

  public createMessage({
    nonce,
    address,
    chainId,
    statement = "Sign in to OpenSea.",
  }: CreateMessageProps) {
    return createSiwxMessage({
      version: "1",
      domain: window.location.host,
      uri: window.location.origin,
      address: address as `0x${string}`,
      chainId,
      nonce,
      statement,
    })
  }

  public exchangeToken?(props: ExchangeProps): Awaitable<Session>

  public tryRefresh?(): Awaitable<Session | undefined>
}
